import { render, staticRenderFns } from "./SupplyAdd.vue?vue&type=template&id=2e362fa4&scoped=true&"
import script from "./SupplyAdd.vue?vue&type=script&lang=js&"
export * from "./SupplyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e362fa4",
  null
  
)

export default component.exports